
import { Helmet } from 'react-helmet-async';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const Login = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to external authentication portal
    const baseUrl = process.env.REACT_APP_BASE_URL || "https://accounts.spiderworks.org";
    const callbackUrl = `${baseUrl}/auth/callback`;
    const externalAuthUrl = `https://access.spiderworks.org/login?type=ACCOUNTS&url=${encodeURIComponent(callbackUrl)}`;
    
    console.log("Redirecting to external authentication portal");
    window.location.href = externalAuthUrl;
  }, [navigate]);

  
  return (
    <div style={{
      display: 'flex', 
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      flexDirection: 'column'
    }}>
      <h2>Redirecting to authentication portal...</h2>
      <div className="spinner" style={{
        border: '4px solid rgba(0, 0, 0, 0.1)',
        borderTop: '4px solid #000',
        borderRadius: '50%',
        width: '40px',
        height: '40px',
        animation: 'spin 1s linear infinite',
        marginTop: '20px'
      }}></div>
      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};
